import { useSelector } from 'react-redux';
import { UIState } from './ui-pmodel';
import { AppState } from './../model';

export const useUI = ():UIState => {
    return useSelector((s:AppState) => s.app.uiState) 
}
